import { Fl44ProposalsApiService } from '@/services/backend/proposals/fl44';
import { Fl223ProposalsApiService } from '@/services/backend/proposals/fl223';
import { CommercialProposalsApiService } from '@/services/backend/proposals/commercial';

export default {
    fl44: new Fl44ProposalsApiService(),
    fl223: new Fl223ProposalsApiService(),
    commercial: new CommercialProposalsApiService()
};
